import React from 'react';

const PrivacyPage = () => {
    return (
        <div className="legal-container">
            <div className="glass-card">
                <h1 className="section-title">Privacy Policy</h1>
                <span className="last-updated">Last updated: April 26, 2026</span>

                <div className="content-block">
                    <p>At Depth Live Wallpaper Pro, we take your privacy seriously. This policy describes how we collect, use, and handle your information when you use our mobile application.</p>

                    <h2>1. Information We Collect</h2>
                    <p><strong>Usage Data:</strong> We may collect anonymous diagnostic and usage data to improve the application performance and stability. This includes device model, OS version, and app interaction logs.</p>
                    <p><strong>Device Sensors:</strong> The application may access your device's accelerometer and gyroscope to enable dynamic wallpaper effects. This data is processed locally on your device and is never transmitted to our servers.</p>
                    <p><strong>Image Access:</strong> To set custom wallpapers, the application requires access to your photo library. Images selected are processed locally and are not uploaded to any remote server.</p>

                    <h2>2. Use of Your Personal Data</h2>
                    <p>The Company may use the collected data for the following purposes:</p>
                    <ul>
                        <li>To provide and maintain our Service.</li>
                        <li>To monitor application performance and fix bugs.</li>
                        <li>To manage your requests and support tickets.</li>
                    </ul>

                    <h2>3. Data Storage and Security</h2>
                    <p>We do not store your personal images or sensor data on our servers. All wallpaper customizations happen locally on your hardware. We use industry-standard security measures to protect any anonymous diagnostic data that may be collected.</p>

                    <h2>4. Children's Privacy</h2>
                    <p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13.</p>

                    <h2>5. Third-Party Services</h2>
                    <p>We may use third-party service providers (like Google Play Services or Firebase) to monitor and analyze the use of our Service. These providers have their own privacy policies.</p>

                    <h2>6. Changes to this Privacy Policy</h2>
                    <p>We may update Our Privacy Policy from time to time. You are advised to review this page periodically for any changes. Changes are effective immediately upon posting.</p>

                    <h2>7. Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy, you can contact us:</p>
                    <ul>
                        <li>By email: support@depthstudio.live</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPage;